function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["disabled", "placeholder", "help", "label", "options", "optionsGrouped", "className", "errorMessage", "onBlur", "onFocus", "onChange", "onKeyDown", "onOptionSelected", "id", "inputRef", "readOnly", "hasValue", "hasError"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/* eslint-disable no-unused-expressions */
import React, { useState, useRef, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import styled, { css } from 'styled-components';
import { Input, InputContainer, StyledError, Label, HelpMsg } from '../BasicInput/StyledInput';
import { ScrollBarContainer } from '../ScrollBarContainer/ScrollBarContainer';
import { IarrowDown2, IarrowUp } from '../AgroIcon/icons';
import { Text } from '../Text/';
var Select = withCssProps(function (_ref) {
  var _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    placeholder = _ref.placeholder,
    _ref$help = _ref.help,
    help = _ref$help === void 0 ? null : _ref$help,
    label = _ref.label,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$optionsGrouped = _ref.optionsGrouped,
    optionsGrouped = _ref$optionsGrouped === void 0 ? [] : _ref$optionsGrouped,
    className = _ref.className,
    errorMessage = _ref.errorMessage,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    onChange = _ref.onChange,
    onKeyDown = _ref.onKeyDown,
    onOptionSelected = _ref.onOptionSelected,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? null : _ref$id,
    inputRef = _ref.inputRef,
    readOnly = _ref.readOnly,
    _ref$hasValue = _ref.hasValue,
    hasValue = _ref$hasValue === void 0 ? false : _ref$hasValue,
    hasError = _ref.hasError,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocus = _useState4[0],
    setIsFocus = _useState4[1];
  var _useState5 = useState(-1),
    _useState6 = _slicedToArray(_useState5, 2),
    focusId = _useState6[0],
    setFocusId = _useState6[1];
  var _useState7 = useState(props.defaultValue || ''),
    _useState8 = _slicedToArray(_useState7, 2),
    value = _useState8[0],
    setValue = _useState8[1];
  var wrapperRef = useRef(null);
  var handleKeyCode = function handleKeyCode(e) {
    var keyCode = e.key;
    e.stopPropagation();
    handleKeyDown(e);
    var up = function up() {
      var back = focusId === -1 ? -1 : focusId - 1;
      setFocusId(back);
      e.preventDefault();
    };
    var down = function down() {
      var next = focusId === options.length - 1 ? focusId : focusId + 1;
      setFocusId(next);
      e.preventDefault();
    };
    var enter = function enter() {
      isOpen && options && handleChange(options[focusId]);
      setIsOpen(!isOpen);
    };
    switch (keyCode) {
      // up arrow
      case 'ArrowUp':
        return up();
      // down arrow
      case 'ArrowDown':
        return down();
      case 'Enter':
        return enter();
      default:
        return null;
    }
  };
  var handleChange = function handleChange(data) {
    if (onOptionSelected) {
      setValue(data.label);
      onOptionSelected(data);
    } else {
      onChange(data);
    }
    setIsOpen(false);
  };
  var handleBlur = function handleBlur(event) {
    setIsFocus(false);
    if (onBlur) {
      onBlur(event);
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (onKeyDown) {
      onKeyDown(event);
    }
  };
  var handleFocus = function handleFocus(event) {
    setIsFocus(true);
    if (onFocus) {
      onFocus(event);
    }
  };
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);
  var getOptions = function getOptions() {
    var opt = [];
    var addOptions = function addOptions(item, idx) {
      opt.push(/*#__PURE__*/React.createElement(Option, {
        role: "button",
        onClick: function onClick() {
          return handleChange(item);
        },
        tabindex: "1",
        className: idx === focusId ? 'focus' : '',
        "aria-labelledby": "dropdown-label",
        key: idx,
        isGroup: optionsGrouped && optionsGrouped.length,
        "data-cy": "agro-select-option"
      }, item.label));
    };
    if (options && options.length) {
      // Add options
      options.map(function (item, idx) {
        return addOptions(item, idx);
      });
    } else if (optionsGrouped && optionsGrouped.length) {
      optionsGrouped.forEach(function (item, idx) {
        opt.push(/*#__PURE__*/React.createElement(GroupTitle, {
          type: "subtitle-md",
          pl: "sm",
          key: idx,
          "data-cy": "agro-select-group-title"
        }, item.groupLabel));
        item.options.map(function (op, index) {
          return addOptions(op, "".concat(index, "-").concat(idx, "-").concat(item.groupLabel));
        });
      });
    }
    return opt;
  };
  return /*#__PURE__*/React.createElement(DropdownContainer, {
    ref: wrapperRef,
    className: className
  }, label ? /*#__PURE__*/React.createElement(SelectLabel, {
    hasError: hasError || errorMessage && errorMessage.length,
    htmlFor: id,
    value: props.value || value || hasValue,
    isFocus: isFocus,
    disabled: disabled || readOnly,
    hasPlaceholder: placeholder && placeholder.length
  }, label) : null, /*#__PURE__*/React.createElement(Dropdown, _extends({
    as: "input",
    role: "button",
    ref: inputRef,
    id: id,
    className: "".concat(!(props.value || value) ? 'placeholder' : '', " ").concat(errorMessage || hasError ? 'input__invalid' : ''),
    "data-cy": "agro-select",
    disabled: disabled,
    placeholder: placeholder,
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    },
    onBlur: function onBlur(e) {
      return handleBlur(e);
    },
    onFocus: function onFocus(e) {
      return handleFocus(e);
    },
    onKeyDown: function onKeyDown(e) {
      return handleKeyCode(e);
    },
    onChange: function onChange(e) {},
    readOnly: true,
    isReadOnly: readOnly,
    isOpen: isOpen,
    tabIndex: readOnly ? -1 : 0
  }, props)), /*#__PURE__*/React.createElement(Arrow, null, isOpen ? /*#__PURE__*/React.createElement(IarrowUp, {
    width: "24px",
    height: "24px",
    fill: "blue600"
  }) : /*#__PURE__*/React.createElement(IarrowDown2, {
    width: "24px",
    height: "24px",
    fill: disabled || readOnly ? 'gray600' : 'gray700'
  })), options && options.length ? /*#__PURE__*/React.createElement(OptionList, {
    as: "ul",
    isOpen: isOpen,
    isGroup: optionsGrouped && optionsGrouped.length
  }, getOptions()) : null, optionsGrouped && optionsGrouped.length ? /*#__PURE__*/React.createElement(OptionList, {
    as: "ul",
    isOpen: isOpen,
    isGroup: optionsGrouped && optionsGrouped.length
  }, getOptions()) : null, errorMessage && errorMessage.length && /*#__PURE__*/React.createElement(StyledError, null, errorMessage), help && help.length && /*#__PURE__*/React.createElement(HelpMessage, {
    disabled: disabled
  }, help));
});
var AgroSelect = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Select, _extends({
    inputRef: ref
  }, props));
});
var optionType = PropTypes.arrayOf(PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.any
}));
var props = {
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  options: optionType,
  optionsGrouped: PropTypes.arrayOf(PropTypes.shape({
    groupLabel: PropTypes.string,
    options: optionType
  })),
  errorMessage: PropTypes.string,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onOptionSelected: PropTypes.func,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  className: PropTypes.string,
  id: PropTypes.string,
  help: PropTypes.string,
  readOnly: PropTypes.bool,
  hasValue: PropTypes.bool,
  hasError: PropTypes.bool
};
AgroSelect.propTypes = props;
Select.propTypes = _objectSpread(_objectSpread({}, props), {}, {
  inputRef: PropTypes.any
});
AgroSelect.displayName = 'AgroSelect';
export { AgroSelect };
var Dropdown = styled(Input).withConfig({
  displayName: "AgroSelect__Dropdown",
  componentId: "sc-1ye64qj-0"
})(["position:relative;cursor:pointer;min-height:18px;color:", ";&.focus{color:", ";}", " ", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.gray900;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.gray900;
}, function (_ref4) {
  var isOpen = _ref4.isOpen,
    theme = _ref4.theme;
  return isOpen && css(["border-radius:8px 8px 0px 0px;border:1px solid ", ";color:", ";"], theme.colors.gray400, theme.colors.gray100);
}, function (_ref5) {
  var isReadOnly = _ref5.isReadOnly,
    theme = _ref5.theme;
  return isReadOnly && css(["color:", ";border-radius:8px;pointer-events:none;"], theme.colors.gray600);
});
var HelpMessage = styled(HelpMsg).withConfig({
  displayName: "AgroSelect__HelpMessage",
  componentId: "sc-1ye64qj-1"
})(["", ""], function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled && css(["color:", ";"], function (_ref7) {
    var theme = _ref7.theme;
    return theme.colors.gray600;
  });
});
var DropdownContainer = styled(InputContainer).withConfig({
  displayName: "AgroSelect__DropdownContainer",
  componentId: "sc-1ye64qj-2"
})(["position:relative;"]);
var Arrow = styled.span.withConfig({
  displayName: "AgroSelect__Arrow",
  componentId: "sc-1ye64qj-3"
})(["position:absolute;pointer-events:none;cursor:pointer;right:16px;top:12px;"]);
var SelectLabel = styled(Label).withConfig({
  displayName: "AgroSelect__SelectLabel",
  componentId: "sc-1ye64qj-4"
})(["cursor:pointer;z-index:1;"]);
var OptionList = styled(ScrollBarContainer).withConfig({
  displayName: "AgroSelect__OptionList",
  componentId: "sc-1ye64qj-5"
})(["display:none;list-style:none;background:", ";border:1px solid ", ";border-top:0px;box-sizing:border-box;box-shadow:0px 3px 6px rgba(0,0,0,0.07);border-radius:0px 0px 8px 8px;padding-top:4px;padding:", ";margin:0px;position:absolute;top:45px;width:100%;max-height:250px;overflow-x:hidden;overflow-y:auto;z-index:5;::-webkit-scrollbar{width:18px;background-color:transparent;}::-webkit-scrollbar-track{border:none;background-color:transparent;}::-webkit-scrollbar-thumb{height:84px;border:6px solid transparent;border-radius:100px;background-color:", ";background-clip:content-box;}", ""], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.white;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.blue600;
}, function (_ref0) {
  var isGroup = _ref0.isGroup;
  return isGroup ? '16px 0px' : '8px 0px 0px 0px';
}, function (_ref1) {
  var theme = _ref1.theme;
  return theme.colors.gray700;
}, function (_ref10) {
  var isOpen = _ref10.isOpen;
  return isOpen && css(["display:block;"]);
});
var Option = styled.li.withConfig({
  displayName: "AgroSelect__Option",
  componentId: "sc-1ye64qj-6"
})(["", " font-size:14px;line-height:20px;display:flex;align-items:center;color:", ";padding:", ";cursor:pointer;&.focus,&.selected{background-color:", ";}&:hover:not(.selected){background-color:", ";}"], function (_ref11) {
  var theme = _ref11.theme;
  return css(["font-family:", ";"], theme.fontFamily);
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.black;
}, function (_ref13) {
  var isGroup = _ref13.isGroup;
  return isGroup ? '10px 32px' : '10px 16px';
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.gray300;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.gray200;
});
var GroupTitle = styled(Text).withConfig({
  displayName: "AgroSelect__GroupTitle",
  componentId: "sc-1ye64qj-7"
})([""]);